module.exports = __webpack_public_path__ + "img/DE04046.7adc4611.svg";